export default function CTASection() {
  return (
    <section className="w-full bg-background-50 py-20 md:py-28">
      <div className="w-full px-6 md:px-10 max-w-[1100px] mx-auto text-center">
        {/* Image */}
        <div className="rounded-3xl overflow-hidden mb-12">
          <img
            src="https://readdy.ai/api/search-image?query=Curated%20fashion%20collection%20display%20with%20premium%20leather%20loafers%2C%20woven%20rattan%20handbag%2C%20silk%20scarves%20and%20artisanal%20jewelry%20arranged%20on%20warm%20honey-toned%20wooden%20surface%2C%20soft%20diffused%20afternoon%20light%2C%20editorial%20luxury%20catalog%20photography%2C%20harmonious%20earthy%20color%20palette%20with%20olive%20green%20and%20warm%20ochre%20accents%2C%20gentle%20botanical%20elements&width=1200&height=600&seq=cta-v2-main-display&orientation=landscape"
            alt="Superbuy Spreadsheet complete product collection"
            title="Access Full Superbuy Spreadsheet Resources"
            className="w-full object-cover"
          />
        </div>

        {/* Text */}
        <div className="max-w-3xl mx-auto">
          <p className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight">
            Ready to explore the{' '}
            <em className="text-foreground-950">Superbuy Spreadsheet</em>?
            <br />
            <span className="text-foreground-500 font-normal">Shop Smarter</span> starting today.
          </p>
        </div>

        {/* CTA */}
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="mt-10 inline-flex items-center gap-2 px-10 py-4 bg-foreground-950 text-background-50 font-semibold text-base rounded-full hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer"
        >
          Buy It Now
          <i className="ri-arrow-right-up-line text-lg w-5 h-5 flex items-center justify-center"></i>
        </a>
      </div>
    </section>
  );
}